import { toast, Slide } from 'react-toastify'
import { Fade } from '../../components/common'
import UpdateStudentLocationForm from '../forms/UpdateStudentLocationForm'
import { getUpdateStudentStatusProps } from '../../selectors/updateStudent'

const mapStateToProps = state => {
  const { submitted } = getUpdateStudentStatusProps(state)
  return {
    submitted,
  }
}

const UpdateStudentLocationPage = ({ submitted }) => {
  useEffect(() => {
    if (submitted) {
      toast['success']('Successfully updated student location', {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 10000,
        transition: Slide,
      })
    }
  }, [submitted])

  return (
    <Fade>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h1>Update Student Location</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <UpdateStudentLocationForm />
          </div>
        </div>
      </div>
    </Fade>
  )
}

export default connect(mapStateToProps)(UpdateStudentLocationPage)
